import * as moment from "moment";
import * as firebase from "firebase";

export class Timeframe {
  begin: Date;
  end: Date;
  constructor(
    begin: firebase.firestore.Timestamp,
    end: firebase.firestore.Timestamp,
  ) {
    this.begin = begin != null ? begin.toDate() : null;
    this.end = end != null ? end.toDate() : null;
  }

  includes(date: Date): boolean {
    if (this.end == null) return false;
    else
      return (
        date.getTime() > this.begin.getTime() &&
        date.getTime() < this.end.getTime()
      );
  }

  toJSON() {
    return {
      begin:
        this.begin == null
          ? null
          : moment(this.begin).format("YYYY-MM-DD"),
      end:
        this.end == null
          ? null
          : moment(this.end).format("YYYY-MM-DD"),
    };
  }

  toString() {
    let begin = "";
    let end = "";
    begin = this.begin == null ? "" : moment(this.begin).format("MM/DD/YY");
    end = this.end == null ? "" : moment(this.end).format("MM/DD/YY");
    return begin + " - " + (end == "" ? "None" : end);
  }
}
